import { render, staticRenderFns } from "./editfoto.vue?vue&type=template&id=70edf2d7&"
import script from "./editfoto.vue?vue&type=script&lang=js&"
export * from "./editfoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports